export default __webpack_public_path__ + "static/media/KOD0024-min.102d77c2.webp";